import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationOptionEmojiCss,
  communicationSubtitleCss,
  communicationTitleCss,
  communicationTitleGroupCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const CommunicationMultiSelectStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${COLORS.WHITE};
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    width: 100%;
    max-width: 375px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 24px 16px 0;
    gap: 16px;
  `,

  TitleGroup: styled.div`
    ${communicationTitleGroupCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  Subtitle: styled.p`
    ${communicationSubtitleCss}
  `,

  Options: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 24px;
    margin-top: auto;
  `,

  OptionButton: styled.button<{ $isSelected: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    background: ${COLORS.WHITE};
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    border-radius: 16px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }
  `,

  OptionEmoji: styled.span`
    ${communicationOptionEmojiCss}
  `,

  OptionLabel: styled.span`
    flex: 1;
    font-family: 'Poppins', sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    text-align: left;
    color: ${COLORS.BLACK};
  `,

  Checkbox: styled.span<{ $isSelected: boolean }>`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#d1d5db')};
    background-color: ${({ $isSelected }) =>
      $isSelected ? '#096ef9' : 'transparent'};
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      display: ${({ $isSelected }) => ($isSelected ? 'block' : 'none')};
      width: 5px;
      height: 9px;
      border: 2px solid ${COLORS.WHITE};
      border-top: none;
      border-left: none;
      transform: rotate(45deg) translate(-1px, -1px);
    }
  `,

  ButtonWrapper: styled.div`
    padding: 16px 16px 24px;
  `,

  Button: styled.button`
    ${communicationButtonCss}
  `,
}
